module.exports = __webpack_public_path__ + "static/office_1-042403c35c20f277f6d4971fc824f343.jpg";